import { useParams } from 'react-router-dom';
import * as Analytics from '../../analytics';
import { EVENTS } from '../../analytics';
import DashboardPage from '../../components/DashboardPage';
import useAuth from '../../hooks/use-auth';
import { useProsumerDashboard } from '../../hooks/use-hydra';
import { ROUTES } from '../../routing';

export default function Dashboard() {
  const { contentSlug } =
    useParams<{
      contentSlug: string;
    }>();

  const trackStats = useProsumerDashboard(contentSlug);
  const { user } = useAuth();

  const getActivityUrl = (
    mission: {
      slug: string;
    },
    activity: {
      slug: string;
    }
  ) =>
    ROUTES.PROSUMER.ACTIVITY.getPath({
      missionSlug: mission.slug,
      activitySlug: activity.slug,
    });

  Analytics.useTrackViewOnMount(EVENTS.PROSUMER.DASHBOARD.VIEW, {
    contentSlug,
  });

  return (
    <DashboardPage
      user={user}
      statsState={trackStats}
      getActivityUrl={getActivityUrl}
      isProsumer
    />
  );
}
